var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"form-control",attrs:{"id":_vm.id,"placeholder":!_vm.disabled ? _vm.placeholder : '',"disabled":_vm.disabled},domProps:{"value":(_vm.model)},on:{"input":function($event){if($event.target.composing)return;_vm.model=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }